import { render, staticRenderFns } from "./transferRecord.vue?vue&type=template&id=276272c0&"
import script from "./transferRecord.vue?vue&type=script&lang=js&"
export * from "./transferRecord.vue?vue&type=script&lang=js&"
import style0 from "./transferRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports